import React, { useState } from 'react';
import { FadeInSection } from './ui/FadeInSection';
import { Shield, ChevronDown } from 'lucide-react';
export function TrustAndFAQ() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const faqs = [{
    q: '¿Necesito saber cocinar?',
    a: 'No. La receta más compleja tiene 6 pasos. La más simple, 3 ingredientes.'
  }, {
    q: '¿Es solo para bajar de peso?',
    a: 'No. El objetivo es controlar la ansiedad y mejorar tu relación con la comida.'
  }, {
    q: '¿Puedo acceder desde el celular?',
    a: 'Sí. PDF compatible con todos los dispositivos. Sin internet luego de descargarlo.'
  }, {
    q: '¿Cuándo recibo el acceso?',
    a: 'Inmediatamente. Menos de 2 minutos después del pago.'
  }, {
    q: '¿La garantía es real?',
    a: '100%. Un mail es suficiente para el reembolso completo.'
  }, {
    q: '¿Por qué $19.990?',
    a: 'Una consulta con nutricionista cuesta entre $8.000 y $15.000. Esto reemplaza meses de consultas por el resto de tu vida.'
  }];
  return <>
      {/* SECTION 15 — GUARANTEE */}
      <section className="bg-warmWhite px-4 py-16 md:py-24" data-id="element-313">
        <div className="max-w-2xl mx-auto text-center" data-id="element-314">
          <FadeInSection data-id="element-315">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-gold/20 rounded-full mb-6" data-id="element-316">
              <Shield className="w-10 h-10 text-chocolate" data-id="element-317" />
            </div>
            <h2 className="text-3xl font-bold text-chocolate mb-8" data-id="element-318">
              GARANTÍA TOTAL DE 7 DÍAS
            </h2>

            <div className="text-lg text-textBody space-y-2 mb-8" data-id="element-319">
              <p data-id="element-320">Probá el Sistema completo.</p>
              <p data-id="element-321">Hacé la primera receta.</p>
              <p data-id="element-322">Aplicá el Ciclo Antídoto.</p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gold/30 mb-8" data-id="element-323">
              <p className="text-xl font-bold text-chocolate mb-4" data-id="element-324">
                Si en 7 días no sentís la diferencia...
                <br data-id="element-325" />
                Te devolvemos el 100%.
              </p>
              <p className="text-textBody" data-id="element-326">
                Sin formularios. Sin preguntas.
                <br data-id="element-327" />
                Un mail es suficiente.
              </p>
            </div>

            <p className="text-2xl font-black text-chocolate uppercase tracking-wide" data-id="element-328">
              Nuestro riesgo. Tu resultado.
            </p>
          </FadeInSection>
        </div>
      </section>

      {/* SECTION 16 — URGENCY/PRICING HONESTY */}
      <section className="bg-cream px-4 py-16" data-id="element-329">
        <div className="max-w-2xl mx-auto" data-id="element-330">
          <FadeInSection data-id="element-331">
            <div className="border-l-4 border-urgency pl-6 py-2" data-id="element-332">
              <h3 className="text-xl font-bold text-chocolate mb-4 flex items-center gap-2" data-id="element-333">
                <span data-id="element-334">⏰</span> Sobre el precio
              </h3>

              <div className="space-y-4 text-textBody" data-id="element-335">
                <p data-id="element-336">
                  No hay "últimas 3 copias".
                  <br data-id="element-337" />
                  Es un producto digital.
                  <br data-id="element-338" />
                  No te vamos a mentir.
                </p>

                <div className="bg-cream p-4 rounded-lg" data-id="element-339">
                  <p className="font-bold text-chocolate mb-2" data-id="element-340">
                    Lo que sí es real:
                  </p>
                  <p data-id="element-341">
                    Este es el precio de lanzamiento.
                    <br data-id="element-342" />
                    Cuando cierre esta fase...
                    <br data-id="element-343" />
                    el precio sube a $37.900.
                  </p>
                </div>

                <p className="font-medium text-chocolate-light" data-id="element-344">
                  Sin cuenta regresiva falsa.
                  <br data-id="element-345" />
                  Sin presión artificial.
                  <br data-id="element-346" />
                  Solo la realidad.
                </p>
              </div>
            </div>
          </FadeInSection>
        </div>
      </section>

      {/* SECTION 18 — FAQ */}
      <section className="bg-chocolate-light px-4 py-16 md:py-24" data-id="element-347">
        <div className="max-w-3xl mx-auto" data-id="element-348">
          <FadeInSection data-id="element-349">
            <h2 className="text-3xl md:text-4xl font-bold text-gold text-center mb-12" data-id="element-350">
              Preguntas Frecuentes
            </h2>

            <div className="space-y-4" data-id="element-351">
              {faqs.map((faq, idx) => <div key={idx} className="bg-chocolate rounded-2xl border border-gold/20 overflow-hidden transition-all duration-300" data-id="element-352">
                  <button onClick={() => setOpenFaq(openFaq === idx ? null : idx)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-353">
                    <span className="font-bold text-warmWhite text-lg pr-4" data-id="element-354">
                      {faq.q}
                    </span>
                    <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 shrink-0 ${openFaq === idx ? 'rotate-180' : ''}`} data-id="element-355" />
                  </button>
                  <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openFaq === idx ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-356">
                    <p className="text-cream/90" data-id="element-357">{faq.a}</p>
                  </div>
                </div>)}
            </div>
          </FadeInSection>
        </div>
      </section>
    </>;
}